import * as CryptoJS from 'crypto-js';

import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  privateKey = environment.cryptoKey;

  encrypt(request: string) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(request), this.privateKey, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    return encrypted;
  }

  decrypt(encrypted: string) {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.privateKey).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }
}
